export default __webpack_public_path__ + "static/media/Vijay.1b6a5353.png";